export default {
    SET_LOGIN_DATA(state, data) {
        state.login = data;
    },
    SET_LOGIN_DATA_OTP(state, data) {
        state.otp = data;
    },

};